import { computed, Injectable, signal } from '@angular/core'

@Injectable({
	providedIn: 'root',
})
export class ChatState {
	readonly devices = signal<ChatDevice[]>([])
	readonly conversations = signal<ChatConversation[]>([])
	readonly activeConversationUuid = signal<string | null>(null)
	readonly messages = signal<ChatMessage[]>([])
	readonly isLoadingConversations = signal(false)
	readonly isLoadingMessages = signal(false)

	readonly activeConversation = computed(() => {
		const uuid = this.activeConversationUuid()

		return this.conversations().find(c => c.conversationUuid === uuid) ?? null
	})
}
